import { Box } from "@mui/material"

export default function WatermarkBackground({ rollNo, dob, opacity = 0.1 }) {

  const convertedDob = dob?.split('-').reverse().join('');
  const watermarkText = convertedDob + rollNo;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        overflow: "hidden",
        pointerEvents: "none",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "-50%",
          left: "-50%",
          width: "200%",
          height: "200%",
          display: "flex",
          flexWrap: "wrap",
          transform: "rotate(45deg)",
          opacity,
        }}
      >
        {Array.from({ length: 500 }).map((_, index) => (
          <Box
            key={index}
            sx={{
              fontSize: "14px",
              color: "black",
              padding: "80px",
              whiteSpace: "nowrap",
            }}
          >
            {watermarkText}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

